module.exports = "/fonts/vendor/bootstrap-icons/bootstrap-icons.woff?0f69dcdb26d3536aa3fec3f600ad5950";